import React, { useState, useEffect } from 'react';
import ContenedorDeCama from './ContenedorDeCama';
import Post from '../../../../../utils/Post';
import HistorialCama from './HistorialCama';

const DisponibilidadCamas = (p) => {
    const data = p.data;
    const semana = p.semana;
    const [opciones, setopciones] = useState({ rancho: -1, valvula: -1, cama: -1 });
    const [historial, sethistorial] = useState([]);
    const [showHistorial, setshowHistorial] = useState(false);
    const [camaHistorial, setcamaHistorial] = useState({ cama: -1, valvula: "", rancho: "" });
    const [camasDiponibles, setcamasDiponibles] = useState(false);

    const getHistorialCama = async (cama) => {
        if (cama < 0 || opciones.valvula < 0) return;
        setshowHistorial(true);
        setcamaHistorial({ cama: cama, valvula: data[opciones.rancho].valvulas[opciones.valvula].valvula, rancho: data[opciones.rancho].rancho });
        let valvula = data[opciones.rancho].valvulas[opciones.valvula].valvula_id;
        let resp = await Post('campo/v2/camas/historial', { cama: cama, valvula: valvula, semana: semana }, 'POST');
        if (!resp.estatus) {
            setshowHistorial(false);
            setcamaHistorial({ cama: -1, valvula: "", rancho: "" });
            sethistorial([]);
            return;
        }
        sethistorial(resp.data);
    }

    const cerrar = () => {
        setshowHistorial(false);
        setcamaHistorial({ cama: -1, valvula: "", rancho: "" });
        sethistorial([]);
    }

    const totalDisponibles = (camas) => {
        let ocupadas = 0;
        camas.forEach(element => {
            if (element.length > 0) ocupadas++;
        });
        return camas.length - ocupadas;
    }
    return (
        <div className='vh-100 dosis vw-100 p-2 overflow blur-l bg-white3' style={{ position: "fixed", top: 0, left: 0, zIndex: 99999 }}>
            {showHistorial && <HistorialCama data={historial} close={cerrar} cama={camaHistorial} />}
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 m-2 text-end'>
                    <button className='btn btn-danger mt-2 shadow ps-5 pe-5 round-xxl' onClick={p.close}>Cerrar</button>
                </div>
                {data.map((rancho, i) => <div key={"recnchos " + i} className='bw-150 m-2'>
                    <button className={'w-100 round-xxl border btn btn-sm btn-' + (opciones.rancho === i ? "warning text-bold border-dark" : "light border-2 border-warning shadow")}
                        onClick={() => { setopciones({ rancho: i, valvula: -1, cama: -1 }) }}>{rancho.rancho}</button>
                </div>)}

                <div className='bw-200 contenedor '>
                    {opciones.rancho >= 0 && <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <label className={opciones.valvula < 0 ? 'text-bold w-100 text-s m-0 p-0 scale-continue-005 text-red3' : 'text-bold w-100 text-xs m-0 p-0'}>Seleccione una valvula</label>
                        <select className='form-control form-control-sm border border-warning border-2 text-bold'
                            value={opciones.valvula}
                            onChange={(e) => { setopciones({ rancho: opciones.rancho, valvula: e.target.value, cama: -1 }) }}
                        >
                            <option value={-1} >Seleccione una valvula</option>
                            {data[opciones.rancho].valvulas.map((valvula, i) => <option key={"valvula " + i} value={i}>{valvula.valvula}</option>)}
                        </select>
                    </div>}
                </div>

                <div className='w-100 m-0 mt-3 p-0'></div>
                <div className='w-100 overflow p-1 bg-light round-m shadow-multi ' style={{ maxHeight: "80vh" }}>
                    <div className='row justify-content-center p-0 w-100 m-0'>
                        {opciones.rancho >= 0 && opciones.valvula >= 0 &&
                            <div className='w-100 mt-1 mb-1 contenedor p-1' style={{ position: 'sticky', top: 0, zIndex: 3 }}>
                                <div className='row justify-content-evenly w-100 m-0 p-0'>
                                    <div className='bw-200 border-bottom text-center bg-white2 blur-l round-m'>
                                        <button className={'btn btn-light shadow border border-2 round-xxl border-warning text-bold'}
                                            onClick={() => setcamasDiponibles(!camasDiponibles)} >
                                            {camasDiponibles ? 'Todas las camas' : 'Solo camas disponibles'}
                                        </button>
                                    </div>
                                    <div className='bw-300 border-bottom text-center bg-white2 blur-l round-m'>
                                        <span className='h2 text-300 text-bold'>{data[opciones.rancho].rancho}</span>
                                        <span className='ms-3 h4 text-bold'>{data[opciones.rancho].valvulas[opciones.valvula].valvula}</span>
                                    </div>

                                    <div className='bw-300 border-bottom text-center bg-white2 blur-l round-m h2 text-300'>
                                        <span className='text-s me-2'>Disponibles</span>
                                        {totalDisponibles(data[opciones.rancho].valvulas[opciones.valvula].camas)}
                                        <span className='text-s ms-2'>De {data[opciones.rancho].valvulas[opciones.valvula].camas.length} camas</span>
                                    </div>
                                </div>

                            </div>
                        }


                        {opciones.rancho >= 0 && opciones.valvula >= 0 && data[opciones.rancho].valvulas[opciones.valvula].camas.map((cama, i) => {
                            if (!camasDiponibles) return (
                                <React.Fragment key={"cama " + i}>
                                    <ContenedorDeCama cama={cama} index={i} historial={getHistorialCama} />
                                </React.Fragment>
                            )

                            let anterior = i - 1;
                            let elementoAnterior = null;
                            let espacio = false;
                            if (anterior >= 0) elementoAnterior = data[opciones.rancho].valvulas[opciones.valvula].camas[anterior];
                            if (elementoAnterior && elementoAnterior.length === 0 && cama.length > 0) espacio = true;

                            if (cama.length === 0) {
                                return (<React.Fragment key={"cama " + i}>
                                    <ContenedorDeCama cama={cama} index={i} historial={getHistorialCama} />
                                </React.Fragment>)
                            } else if (espacio) return <div key={"cama " + i} className='m-0 p-0' style={{ width: "50px", minWidth: "50px" }}></div>

                            /*let anterior = i - 1;
                            let elementoAnterior = null;
                            if (anterior >= 0) elementoAnterior = data[opciones.rancho].valvulas[opciones.valvula].camas[anterior];
                            if (elementoAnterior && elementoAnterior.length === 0 && cama.length > 0) return (<div className='bw-50 bg-warning' key={"cama " + i}></div>);
                            if (elementoAnterior && elementoAnterior.length > 0 && cama.length > 0) return <div key={"cama " + i} className='hide'></div>;
                            if (cama.length === 0) {
                                return (<React.Fragment key={"cama " + i}>
                                    <ContenedorDeCama cama={cama} index={i} historial={getHistorialCama} />
                                </React.Fragment>)
                            }
                            return (<div key={"cama " + i} className='hide'></div>)*/

                        })}
                    </div>
                    {opciones.rancho < 0 && <div className='w-100 p-3 h3 text-center mt-5 text-bold'>Para empezar seleccione un Rancho en los botones arriba</div>}
                    {opciones.rancho >= 0 && opciones.valvula < 0 && <div className='w-100 p-3 h3 text-center mt-5 text-bold'>Seleccione una valvula para ver la información de sus camas</div>}
                </div>
            </div>
        </div>
    )
}

export default DisponibilidadCamas;